export default __webpack_public_path__ + "fonts/75554b73256e4f878316b614536eb897.svg";